import React from "react";
import { BsFillTelephoneInboundFill } from "react-icons/bs";
import { ImLocation } from "react-icons/im";
import { AiOutlineSchedule } from "react-icons/ai";
import { HiMail } from "react-icons/hi";

const Contact = () => {
  const contactInfo = [
    {
      icon: BsFillTelephoneInboundFill,
      title: "Contact",
      details: [
        { text: "+961-03644705", href: "tel:+96103644705" },
        { text: "info@hexapi.tech", href: "mailto:info@hexapi.tech" },
      ],
    },
    {
      icon: ImLocation,
      title: "Address",
      details: [{ text: "West Bekaa, Lebanon" }],
    },
    {
      icon: AiOutlineSchedule,
      title: "Working Hours",
      details: [{ text: "Monday - Friday" }, { text: "8:00 AM - 4:00 PM" }],
    },
  ];

  return (
    <section id="contact" className="py-10 lg:py-14 bg-white">
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="section-subheading">Get In Touch</span>
          <h2 className="section-heading">Contact Us</h2>
          <div className="w-20 h-1 bg-primary-500 mx-auto mt-4 rounded-full"></div>
          <p className="text-neutral max-w-2xl mx-auto mt-4">
            Ready to start your next project? Get in touch with us and let's
            discuss how we can help bring your ideas to life.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-8 max-w-4xl mx-auto">
          {contactInfo.map((item, index) => (
            <div
              key={index}
              className="text-center p-4 md:p-8 bg-neutral-light rounded-xl
                         hover:shadow-card-hover transition-all duration-300"
            >
              <div
                className="w-12 h-12 md:w-16 md:h-16 bg-primary-500 rounded-full flex items-center
                            justify-center mx-auto mb-3 md:mb-6"
              >
                <item.icon className="text-xl md:text-2xl text-white" />
              </div>
              <h4 className="text-base md:text-xl font-semibold text-neutral-dark mb-2 md:mb-4">
                {item.title}
              </h4>
              <div className="space-y-0.5 md:space-y-1">
                {item.details.map((detail, i) =>
                  detail.href ? (
                    <a
                      key={i}
                      href={detail.href}
                      className="block text-xs md:text-base text-neutral hover:text-primary-500 transition-colors"
                    >
                      {detail.text}
                    </a>
                  ) : (
                    <p key={i} className="text-xs md:text-base text-neutral">
                      {detail.text}
                    </p>
                  )
                )}
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="bg-primary-500 rounded-2xl p-8 md:p-12 max-w-3xl mx-auto">
            <HiMail className="w-12 h-12 text-white mx-auto mb-4" />
            <h3 className="text-2xl font-semibold text-white mb-4">
              Have a Project in Mind?
            </h3>
            <p className="text-primary-100 mb-6 max-w-lg mx-auto">
              Whether you need a new website, mobile app, or custom electronics
              solution, we're here to help.
            </p>
            <a
              href="mailto:info@hexapi.tech"
              className="inline-flex items-center px-8 py-4 bg-white text-primary-500
                         font-semibold rounded-lg hover:bg-primary-50
                         transition-all duration-300"
            >
              Send Us an Email
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
